export const acceptSuccessMessage = 'Successfully accepted time!';
export const declineSuccessMessage = 'Successfully declined requests!';
export const declineErrorMessage = 'Error declining this time!';
export const techSuggestString = 'has suggested a time change for this service.';
export const declineButton = 'decline';
export const declineAllButton = 'decline all';
export const noActor = 'no actor ';
